/*    
<summary>
  This functional component shows the driver details.
  Developer:Aashish Singh, Created Date: 09-Oct-2023
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useStore } from "../../../contexts/StoreProvider";
import { ITruckList } from "../../../models/response/ITruckResponse";
import SpinnerLoader from "../../../shared-components/Loader/SpinnerLoader";
import { formatMessage } from "../../../translations/formatMessage";
import NoData from "../../../assets/Images/no_record.png";
import { FormattedMessage } from "react-intl";
import { getUserType } from "../../../helpers/localStorages.helper";
import UserType from "../../../constants/userType.constant";
import Grid, { getColumns } from "../../../shared-components/Grid/Grid";
import { ColumnType } from "../../../constants/enums/gridColumnTypeEnum";

interface IProps {
  selectedData: ITruckList | undefined;
}

const TruckDetails = (props: IProps) => {
  const { truckStore } = useStore();
  const {
    getReadAssetInfoTruckStateDetails,
    readAssetInfoTruckState,
    sendReadAssetInfoTruckState,
    getReadAssetInfoTruckStateDetailsDownLinkInformation,
  } = truckStore;
  // console.log(getReadAssetInfoTruckStateDetails.DownLinkInformation);
  const [data, setData] = useState<any>(
    getReadAssetInfoTruckStateDetails.DownLinkInformation
  );

  const columns = getColumns<any, number>([
    {
      columnType: ColumnType.TextHeader,
      accessorKey: "Rfid",
      displayName: "rfid",
    },
    {
      columnType: ColumnType.TextHeader,
      accessorKey: "VehicleNumber",
      displayName: "vehicle_number",
    },
  ]);

  useEffect(() => {
    // Mock API response
    const response = getReadAssetInfoTruckStateDetails.DownLinkInformation;
    const unescapedString = response
      .replace(/\\"/g, '"')
      .replace(/\\\\/g, "\\");
    try {
      // Parse the JSON string
      const parsedData = JSON.parse(unescapedString);
      setData(parsedData); // Set the parsed data to state
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
  }, [getReadAssetInfoTruckStateDetails, setData]);
  /**
   * This function calls the "GetDriverByIdService" store funtion that get group data from API
   */
  return (
    <React.Fragment>
      {(readAssetInfoTruckState.inProgress ||
        sendReadAssetInfoTruckState.inProgress) && <SpinnerLoader />}
      {getReadAssetInfoTruckStateDetails.DownLinkInformation ? (
        <>
          <div className="drivercard">
            <div className="row my-3">
              <div className="col-12">
                <div className="mt-4">
                  <div className="drivingLicence">
                    <small className="h6">{formatMessage("truck_id")}</small>
                    <p>
                      {getReadAssetInfoTruckStateDetails?.AssetId}
                      {/* {JSON.parse(
                        getReadAssetInfoTruckStateDetails?.DownLinkInformation
                      )} */}
                    </p>
                  </div>
                </div>
                <div className="row align-items-center g-0 mt-5">
                  <div className="col-12">
                    <h3 className="h6">{"DownloadLink Information :"}</h3>
                    <h4 className="m-0 text-break">
                      {getUserType() === UserType.SuperAdmin && (
                        <pre
                          style={{
                            backgroundColor: "#f4f4f4",
                            padding: "10px",
                            borderRadius: "5px",
                          }}
                        >
                          {JSON.stringify(data, null, 2)}
                        </pre>
                      )}
                      {(getUserType() === UserType.CleintAdmin ||
                        getUserType() === UserType.ClientUser) && (
                        <>
                          {getReadAssetInfoTruckStateDetailsDownLinkInformation.length >
                            0 &&
                            getReadAssetInfoTruckStateDetailsDownLinkInformation.map(
                              (info: any) => {
                                return (
                                  <div>
                                    {/* <h4 className="h6">
                                      {info?.AssetId -
                                        info.ClientId -
                                        info.TId -
                                        info.Pos -
                                        info.Rfid -
                                        info.VehicleNumber}
                                    </h4> */}
                                    <Grid
                                      data={info.Vehicles}
                                      columns={columns}
                                      isInProgress={
                                        readAssetInfoTruckState.inProgress ||
                                        sendReadAssetInfoTruckState.inProgress
                                      }
                                      hiddenColumns={["Id"]}
                                    />
                                  </div>
                                );
                              }
                            )}
                        </>
                      )}
                    </h4>
                  </div>
                </div>
                <div className="row align-items-center g-0 mt-4">
                  <div className="col-12">
                    <div className="h6">{"Updated Timestamp:"}</div>
                    <div className="h5">
                      {" "}
                      {getReadAssetInfoTruckStateDetails.UpdatedAt}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="text-center h3">
          <div className="no_data_table">
            <div className="no_data w-100 text-center">
              <img src={NoData} alt="NOData" className="NOData" />
              <h1 className="fs-2">
                <FormattedMessage id="message_no_datafound" />
              </h1>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default observer(TruckDetails);
